__turbopack_context__.v({
  "backgroundGradient": "Wallet-module__TVNLEq__backgroundGradient",
  "backgroundGradientContainer": "Wallet-module__TVNLEq__backgroundGradientContainer",
  "desktopOnly": "Wallet-module__TVNLEq__desktopOnly",
  "line": "Wallet-module__TVNLEq__line",
  "mobileOnly": "Wallet-module__TVNLEq__mobileOnly",
  "modal": "Wallet-module__TVNLEq__modal",
  "newWalletLink": "Wallet-module__TVNLEq__newWalletLink",
  "tabSection": "Wallet-module__TVNLEq__tabSection",
  "tabs": "Wallet-module__TVNLEq__tabs",
  "title": "Wallet-module__TVNLEq__title",
  "titleActionButton": "Wallet-module__TVNLEq__titleActionButton",
  "titleActionIcon": "Wallet-module__TVNLEq__titleActionIcon",
  "walletHeader": "Wallet-module__TVNLEq__walletHeader",
  "walletHistoryStatus": "Wallet-module__TVNLEq__walletHistoryStatus",
});
